import Button from "../../../../ui/button";
import { ComplexAnimatedModal } from "../../../../ui/modal/ComplexAnimatedModal";
import styles from "./styles.module.scss";

interface IModalTradeInProps {
  isOpen: boolean;
  title: string;
  text: string;
  offsetY: number;
  onRedirect: () => void;
  onDismiss: (value: boolean) => void;
}

const ModalRedirectToPageWizard = ({
  isOpen,
  text,
  title,
  offsetY,
  onRedirect,
  onDismiss,
}: IModalTradeInProps) => {
  return (
    <ComplexAnimatedModal
      opened={isOpen}
      onClose={() => onDismiss(false)}
      offsetY={offsetY}
    >
      <div className={styles.modalRedirectToPageWizard}>
        <div className={styles.modalRedirectToPageWizard__container}>
          <div className={styles.modalRedirectToPageWizard__title}>{title}</div>
          <div className={styles.modalRedirectToPageWizard__text}>{text}</div>
          <div className={styles.modalRedirectToPageWizard__button}>
            <Button label="Перейти к оформлению заявки" onClick={onRedirect} />
          </div>
        </div>
      </div>
    </ComplexAnimatedModal>
  );
};
export default ModalRedirectToPageWizard;
